import Vue from "vue";
import __dayjs from "dayjs";

import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

__dayjs.extend(utc);
__dayjs.extend(timezone);
__dayjs.locale("ko");
__dayjs.tz.setDefault("Asia/Seoul");

let plugins = {
    /** @this {typeof __dayjs} */
    $toLater(date) {
        let s = this(date).diff(this(), "seconds");
        if (s <= 0) return "만료";
        if (s < 60) return `${s}초 후`;

        let m = Math.floor(s / 60);
        if (m < 60) return `${m}분 후`;

        let h = Math.floor(m / 60);
        if (h < 24) return `${h}시간 후`;

        let d = Math.floor(h / 24);

        return `${d}일 후`;
    },
};

Object.entries(plugins).forEach(([key, value]) => (__dayjs[key] = value));

/** @type {typeof __dayjs & typeof plugins} */
export const dayjs = __dayjs;
export default dayjs;

/**
 * @param {Vue} Vue
 * @param {*} options
 */
const install = function(Vue, options) {
    Vue.prototype.$dayjs = dayjs;
};

Vue.use({ install });
